import { showToast } from '../toast';

let inlineCodeCopyDelegated = false;

function fallbackCopyText(text: string): boolean {
  try {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();
    const ok = document.execCommand('copy');
    document.body.removeChild(textarea);
    return ok;
  } catch {
    return false;
  }
}

export function copyText(text: string, onCopied?: () => void, onFailed?: () => void): void {
  if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
    navigator.clipboard.writeText(text).then(() => onCopied?.()).catch(() => {
      if (fallbackCopyText(text)) onCopied?.();
      else onFailed?.();
    });
    return;
  }
  if (fallbackCopyText(text)) onCopied?.();
  else onFailed?.();
}

export function ensureInlineCodeCopyDelegation(): void {
  if (inlineCodeCopyDelegated) return;
  inlineCodeCopyDelegated = true;
  document.addEventListener('click', (event) => {
    const target = event.target instanceof HTMLElement
      ? event.target.closest('.msg-bubble code:not(pre code)') as HTMLElement | null
      : null;
    if (!target) return;
    const text = target.textContent || '';
    if (!text.trim()) return;
    copyText(text, () => {
      target.dataset.copied = '1';
      showToast('已复制');
      window.setTimeout(() => { delete target.dataset.copied; }, 1200);
    }, () => showToast('复制失败'));
  });
}
